import React from "react";
import { useDispatch } from "react-redux";
import { ConvertTagsToHtml } from "../helpers/TagHelper";
const Row = ({ row }) => {
  // const{uploadedFile} = useSelector((state) => state.file)
  const dispatch = useDispatch();

  let html = ConvertTagsToHtml(row.segmentText);
  const parser = new DOMParser();
  //const document = parser.parseFromString(html.ResultHTML, "text/html");
  //console.log("PARSED HTML", document)
  let div = document.createElement("div");
  div.innerHTML = html.ResultHTML.trim();
  //console.log("ROW", row)

  // console.log("From row",uploadedFile)

  // const rowClickHandler = () => {
  //   const selectedRow = rows.map((row) => {
  //     if(row.id === id){
  //       row.selected = true
  //     }
  //   });
  //  console.log(row);
  //  dispatch(updateFile((row.id - 1), true));
  //  //dispatch(changeText((row.id - 1), "Test tekst"))
  //  setUpload({...upload})
  // }
  // const rowDoubleClickHandler = () => {
  //   const selectedRow = rows.map((row) => {
  //     if(row.id === id){
  //       row.selected = false;
  //     }
  //   });
  //   dispatch(updateFile((row.id - 1), row.selected));
  //  setUpload({...upload})

  return (
    
      <div className="card mb-1">
        <div className="translation-line row mx-1">
          {/*<div className="col-5 text-start align-self-center">*/}
          {/*  <p className="prop-name ">{row.filterSpecificNotes}</p>*/}
          {/*</div>*/}
          <div className="col-12 text-start">
            <p className="prop-content" dangerouslySetInnerHTML={{__html:html.ResultHTML}}></p>
          </div>
        </div>
      </div>
   
  );
};

export default Row;
